import { generateVuexCrud } from '@/utilities/crud/vuex';

const crud = generateVuexCrud({
    single: 'inventoryCategory',
    multiple: 'inventoryCategories',
});

const state = {
    ...crud.state,
};

const actions = {
    ...crud.actions,
};

const mutations = {
    ...crud.mutations,
};

export default {
    state,
    actions,
    mutations,
};
